import React from 'react'
import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import RiparideSmallLogo from '../icons/RiparideSmallLogo'

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const HeadingWrapper = styled(Column)`
  width: 34%;
  position: relative;

  ${mediaMax.md`
    align-items: flex-start;
  `}

  h1 {
    color: ${({ theme }) => theme.brand.forest};
    font-size: 40px;
    font-weight: 400;
    margin-bottom: 16px;
    max-width: 380px;
    flex-shrink: 0;

    ${mediaMax.md`
        font-size: 32px;
        max-width: none;
      `}

    svg {
      position: absolute;
      top: -80px;
      height: 55px;
      color: ${({ theme }) => theme.brand.jungle};

      ${mediaMax.md`
        height: 30px;
        top: -50px;
      `}
    }
  }
`

const TextWrapper = styled(Column)`
  width: 66%;

  p {
    font-size: 24px;
    line-height: 1.5;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.textGreyDarker};
    max-width: 720px;

    ${mediaMax.md`
     font-size: 18px;
     line-height: 1.7;
   `}
  }
`

const InfoWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 140px 0 60px 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  ${mediaMax.md`
    padding: 80px 0 0 0;
  `}

  div {
    width: 100%;
    display: flex;

    ${mediaMax.md`
      flex-direction: column;
    `}

    ${media.md`
      justify-content: space-between;
    `}
  }
`

const Brief = ({ text }: { text: React.ReactNode }) => {
  return (
    <InfoWrapper>
      <div>
        <HeadingWrapper>
          <h1>
            <RiparideSmallLogo />
            What are Riparide Stories?
          </h1>
        </HeadingWrapper>
        <TextWrapper>
          <p>{text}</p>
        </TextWrapper>
      </div>
    </InfoWrapper>
  )
}

export default Brief
